import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Gothscepter - A platform dedicated to gothic culture, fashion, and lifestyle" 
          style={{ 
            width: '100%', 
            maxHeight: '400px', 
            objectFit: 'cover' 
          }} 
        />
        <p className="eyebrow">Gothscepter - Embrace Your Dark Side</p>
        <h1>Discover the Essence of Gothic Culture</h1>
        <p className="lede">
          Dive into a world where gothic fashion, art, and lifestyle converge. Explore our curated collections and connect with a community that celebrates individuality and creativity.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/community" target="_blank" className="secondary">
            Join Our Community
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Explore Unique Fashion</h2>
          <p>
            Find clothing and accessories that express your unique style. Our selection features bold designs and quality craftsmanship.
          </p>
        </article>
        <article>
          <h2>Connect with Like-Minded Individuals</h2>
          <p>
            Join our vibrant community of gothic enthusiasts. Share your passion, attend events, and connect with others who appreciate the darker aesthetic.
          </p>
        </article>
        <article>
          <h2>Stay Inspired</h2>
          <p>
            Discover articles, interviews, and resources that celebrate gothic culture. Stay updated on trends and find inspiration for your next look.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;